module.exports = __webpack_public_path__ + "images/stickers/taco-embarrassed@2x.02663f87e33a2c798280.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-embarrassed@2x.png
// module id = sOky
// module chunks = 1